// @flow
import * as React from 'react';
import AuthState from './AuthState';
// $FlowFixMe
export const AuthContext = React.createContext(new AuthState());

export function redirectToAuthService() {
  const authServiceUrl = `https://${process.env.BUILD_ENV_PREFIX ||
    ''}auth.powerreviews.com`;
  const currentHref = encodeURIComponent(window.location.href);

  window.location.replace(`${authServiceUrl}?continue_to=${currentHref}`);
}

export function withAuthError(fn: (...args: Array<*>) => fetch) {
  return (...args: Array<*>) => {
    return fn(...args).catch((err: Error) => {
      if (err.status && err.status === 401) {
        redirectToAuthService();
      }

      throw err;
    });
  };
}

export const useAuth = () => {
  // $FlowIssue
  return React.useContext(AuthContext);
};



// WEBPACK FOOTER //
// ./src/ducks/auth-context.js